// src/client/components/Wordmark.tsx
// The three-bar Cobalt logo + the word "thandizo" in Inter. Used on the
// splash, in the home top bar, and on the profile header card.
import styles from './Wordmark.module.css';

interface Props {
  /** Logo glyph height in px. The wordmark text scales with it. */
  size?: number;
  /** When true, renders inside a rounded white pill (used on splash). */
  contained?: boolean;
  /** When true, hides the wordmark text and shows the glyph only. */
  glyphOnly?: boolean;
  className?: string;
}

export default function Wordmark({ size = 22, contained = false, glyphOnly = false, className }: Props) {
  const inner = (
    <div className={styles.row} style={{ gap: 10 }}>
      <svg width={size + 6} height={size + 6} viewBox="0 0 32 32" aria-hidden>
        <rect x="6" y="7"  width="20" height="4" rx="1" fill="#9CC5F0" />
        <rect x="6" y="14" width="20" height="4" rx="1" fill="#60A5E8" />
        <rect x="6" y="21" width="20" height="4" rx="1" fill="#2E82D6" />
      </svg>
      {!glyphOnly && (
        <span className={styles.text} style={{ fontSize: size + 4 }}>
          Thandizo
        </span>
      )}
    </div>
  );

  const cls = [contained ? styles.contained : styles.bare, className].filter(Boolean).join(' ');
  return (
    <div className={cls} role="img" aria-label="Thandizo">
      {inner}
    </div>
  );
}
